import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/user/auth.service';
import { Router } from '@angular/router';
import { IndicatorsService } from '../../services/indicators/indicators.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-indicators',
  templateUrl: './indicators.component.html',
  styleUrls: ['./indicators.component.css']
})
export class IndicatorsComponent implements OnInit {

  public indicators: Map <string, any>;
  public arrayIndicatorRows: Array<{name: string, icon: string, indicators: Array<string>}>;
  public indicatorTitles: any;
  public referencePeriod: any;
  public pageTitle: string;

  constructor (
    private router: Router,
    private authService: AuthService,
    private indicatorService: IndicatorsService
  ) { }

  ngOnInit() {
    this.pageTitle = 'indicator.mains';
    this.indicatorTitles = new Map([
      ['total_revenue_ytd', 'total_revenue_ytd'],
      ['total_visits_ytd',  'total_visits_ytd'],
      ['avg_spent_per_visit', 'avg_spent_per_visit'],
      ['sold_volume_ytd', 'sold_volume_ytd'],
      ['promo_value_incidence_ytd', 'promo_value_incidence_ytd'],
      ['pl_volume_quote_ytd', 'pl_volume_quote_ytd'],
      ['loyalty_incidence_ytd', 'loyalty_incidence_ytd'],
      ['customers_with_transactions_ytd', 'customers_with_transactions_ytd'],
      ['new_customers_ytd', 'new_customers_ytd'],
      ['pdv_count_ytd', 'pdv_count_ytd'],
      ['new_pdv_ytd', 'new_pdv_ytd'],
      ['parity_pdv_ytd', 'parity_pdv_ytd'],
      ['points_provided_ytd', 'points_provided_ytd'],
      ['redeemed_points_ytd', 'redeemed_points_ytd'],
      ['provisioned_ytd', 'provisioned_ytd']
    ]);

    this.indicators = new Map();
    this.arrayIndicatorRows = [];

    this.arrayIndicatorRows.push(
      { name: 'YearVisitMeasures', icon: 'fa fa-euro', indicators: ['TotalRevenueYTD', 'TotalVisitsYTD', 'AvgSpentPerVisitYTD']},
      { name: 'YearVolumes', icon: 'fa fa-tags', indicators: ['SoldVolume', 'PromoValueIncidence', 'QuotaPLVolumi']},
      { name: 'YearCustomers', icon: 'fa fa-user', indicators: ['LoyaltyIncidence', 'CustomersWithTransactions', 'NewCustomers']},
      { name: 'YearPdv', icon: 'fa fa-home', indicators: ['SalesPoint', 'NewSalesPoint', 'ParitySalesPoint']},
      { name: 'YearPoints', icon: 'fa fa-credit-card', indicators: ['ProvidedPoint', 'RedeemedPoint', 'ProvisionedPoint']}
    );


    this.indicatorService.getReferenceDates('OverviewIndicators').subscribe((response) => {
      // date format returned by BE should be a string like '1968-11-16T00:00:00'.
      console.log('DATE DI RIFERIMENTO WS RESPONSE:', response);
      this.referencePeriod = response[0];
    });

    const requestsArray = [];

    for (const item of this.arrayIndicatorRows) {
      item.indicators.forEach( indicator => {
        requestsArray.push(this.indicatorService.getGeneralIndicator(indicator));
      });
    }

    Observable.zip(...requestsArray).subscribe((res) => {
      for (const single of res) {
        console.log('single', single);
        // TODO: Dovrebbe servire solo il titolo, come elemento di visualizzazione e non il name
        single[0].title = this.indicatorTitles.get(single[0].name);
        single[0].name = single[0].title;
        this.indicators.set(single[0].key, single[0]);
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/views/indicators/indicators.component.ts